import React from "react";
import { useSearchParams } from "react-router";
import { resolvePageSurfaceWidthClassName } from "../utils/pageSurfaceLayout.js";
import DispatchAlertCapturesPage from "./DispatchAlertCapturesPage.jsx";
import DispatchAlertCaptureSettingsCard from "./DispatchAlertCaptureSettingsCard.jsx";
import DispatchCaptureHistorySwitcher from "./DispatchCaptureHistorySwitcher.jsx";
import CombinedCaptureActivityHistory from "./CombinedCaptureActivityHistory.jsx";
import ReassignmentDiagnosticsPage from "./ReassignmentDiagnosticsPage.jsx";
import ReassignmentDiagnosticsSettingsCard from "./ReassignmentDiagnosticsSettingsCard.jsx";
import ReportActionCaptureHistory from "./ReportActionCaptureHistory.jsx";
import JournalCaptureHistory from "./JournalCaptureHistory.jsx";
import EpiQuestionHistory from "./EpiQuestionHistory.jsx";
import SollioUniagOrderImportHistory from "./SollioUniagOrderImportHistory.jsx";
import { joinClasses } from "./resultsPrimitives/shared.js";

const SYSTEM_CONFIG_SURFACE_WIDTH_CLASS_NAME = resolvePageSurfaceWidthClassName("system_config");

export default function DispatchCapturesHubPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedView = searchParams.get("view");
  const active = ["errors", "imports", "reports", "journal", "robot", "source_changes", "consolidation", "reassignment"].includes(requestedView)
    ? requestedView
    : "all";

  return (
    <div
      className={joinClasses([
        "mx-auto grid w-full max-w-full min-h-min min-w-0 gap-3 overflow-x-clip px-4 pb-6 pt-0 max-[720px]:px-4",
        SYSTEM_CONFIG_SURFACE_WIDTH_CLASS_NAME,
      ])}
      data-dispatch-captures-hub="true"
    >
      {active !== "journal" && active !== "robot" && <section className="grid gap-3 rounded-[4px] border border-black/6 bg-white px-4 py-3.5 shadow-[0_14px_34px_rgba(15,23,42,0.05)]">
        {active === "errors" ? <DispatchAlertCaptureSettingsCard /> : <ReassignmentDiagnosticsSettingsCard />}
      </section>}

      <div className="flex flex-wrap items-center justify-between gap-2">
        <DispatchCaptureHistorySwitcher
          active={active}
          onSelect={(nextView) => {
            setSearchParams(nextView === "all" ? {} : { view: nextView }, { replace: true });
          }}
        />
      </div>

      {active === "all" ? (
        <CombinedCaptureActivityHistory />
      ) : active === "reassignment" || active === "source_changes" || active === "consolidation" ? (
        <ReassignmentDiagnosticsPage key={active} embedded activityScope={active === "reassignment" ? "dispatch" : active} />
      ) : active === "errors" ? (
        <DispatchAlertCapturesPage embedded />
      ) : active === "journal" ? (
        <JournalCaptureHistory />
      ) : active === "robot" ? (
        <EpiQuestionHistory />
      ) : active === "reports" ? (
        <ReportActionCaptureHistory />
      ) : (
        <SollioUniagOrderImportHistory />
      )}
    </div>
  );
}
